<template>
    <div>
        <modal-hand-over-to-partner ref="handOverDialog" :order="order"/>
        <modal-set-prices ref="setPricesDialog" :order="order"/>
        <modal-set-quantity ref="setQuantityDialog" :order="order"/>
        <modal-set-description ref="setDescriptionDialog" :order="order"/>
        <modal-cancel-order ref="cancelOrderDialog" :order="order"/>
        <v-container class="grey lighten-5" fluid>
            <v-row>
                <v-col cols="12">
                    <h4>Firma obsługująca zamówienie</h4>
                    <v-data-table v-if="loadingDetails || details.length"
                                  :headers="headers"
                                  :items="companyDetails"
                                  hide-default-header
                                  hide-default-footer
                                  :server-items-length="20"
                                  :loading="loadingDetails"
                    >
                        <template v-slot:item.name="{ item }">
                            <span v-if="'branchId' === item.name" class="font-weight-medium">
                                Oddział
                            </span>
                            <span v-if="'company' === item.name" class="font-weight-medium">
                                Nazwa firmy
                            </span>
                            <span v-if="'branchName' === item.name" class="font-weight-medium">
                                Nazwa oddziału
                            </span>
                        </template>
                        <template v-slot:item.value="{ item }">
                            <router-link
                                v-if="'branchId' === item.name"
                                :to="{name: 'price-list-company-branch-details', params: {companyId: item.value.company, id: item.value.branch}}"
                            >
                                Oddział
                            </router-link>
                            <span v-else-if="'company' === item.name">
                                {{ item.value.name }} NIP: {{ item.value.nip }}
                            </span>
                            <span v-else-if="'branchName' === item.name">
                                {{ item.value }}
                            </span>
                        </template>
                    </v-data-table>
                    <h4>Szczegóły zamówienia</h4>
                    <div class="mt-3 elevation-1">
                        <v-data-table v-if="loadingDetails || details.length"
                                      :headers="headers"
                                      :items="details"
                                      hide-default-header
                                      hide-default-footer
                                      :server-items-length="20"
                                      :loading="loadingDetails"
                        >
                            <template v-slot:item.name="{ item }">
                                <span class="font-weight-medium">
                                  {{ item.name }}
                                </span>
                            </template>
                            <template v-slot:item.value="{ item }">
                                <a v-if="'Firma' === item.name"
                                   @click="onCompanyClicked"
                                >
                                    <span v-html="getCompanyName(item.value)"></span>
                                </a>
                                <span v-else-if="'Status' === item.name">
                                    {{ getOrderStatusText(item.value) }}
                                </span>
                                <span v-else-if="'Ilość' === item.name">
                                    {{ item.value }} {{ order.service.type.isCarRental ? 'dni' : order.service.unit }} <a @click="setQuantity" v-if="!order.service.type.isCarRental">zmień ilość</a>
                                </span>
                                <span v-else-if="'Opis odpadu' === item.name">
                                    {{ item.value }} <a @click="setDescription">zmień opis</a>
                                </span>
                                <span v-else-if="'Użytkownik' === item.name">
                                    <router-link :to="{name: 'user-details', params: { id: item.value.id }}">
                                      {{ item.value.email }}
                                    </router-link>
                                </span>
                                <span v-else-if="'Cena' === item.name">
                                    <span v-if="item.value">
                                      <span v-if="order.service.type.isCarRental">
                                        {{((parseFloat(item.value) + parseFloat(order.withInsurance ? order.insurancePrice : 0)) * quantity).toFixed(2) }} zł
                                        <span v-if="order.withInsurance"> z ubezpieczeniem ({{order.insurancePrice }} dzień netto) </span>
                                      </span>
                                        <span v-else>
                                          {{ item.value }} zł{{ order.priceForOrder ? '' : '/' + order.service.unit }}
                                        </span>
                                    </span>
                                    <span v-if="order.undefinedPrice">
                                        Nie da się określić ceny
                                    </span>
                                     <a @click="setPrices">uzupełnij ceny</a>
                                </span>
                                <span v-else-if="'Cena partnera' === item.name">
                                </span>
                                <span v-else-if="'Cena partnera' === item.name">
                                    <span v-if="item.value">
                                        {{ item.value }} zł{{ order.priceForOrder ? '' : '/' + order.service.unit }}
                                    </span>
                                    <span v-else>
                                        -
                                    </span>

                                </span>
                                <span v-else-if="'Utworzono' === item.name">
                                    {{ localDateTime(item.value) }}
                                </span>
                                <span v-else-if="'Do kiedy odpad zostanie odebrany' === item.name">
                                    {{ item.value ? item.value.split('T')[0] : '' }}
                                </span>
                                <span v-else-if="'Typ firmy' === item.name">
                                    {{ companyTextTypes(item.value) }}
                                </span>
                                <span v-else-if="'Zaakceptował regulamin' === item.name">
                                    {{ order.status === 'pendingApproval' ? 'Nie' : 'Tak' }}
                                </span>
                                <span v-else-if="'Zdjęcia' === item.name">
                                  <span v-for="photo in item.value" :key="photo.storageId">
                                    <v-img
                                        :src="apiBaseUrl + '/api/files/' + photo.storageId + '?extension=' + photo.extension"
                                        aspect-ratio="1"
                                        class="grey lighten-2"
                                    ></v-img>
                                  </span>
                                </span>
                                <span v-else-if="'Zdjęcie' === item.name">
                                    <v-img
                                        :src="apiBaseUrl + '/api/files/' + item.value.storageId + '?extension=' + item.value.extension"
                                        aspect-ratio="1"
                                        class="grey lighten-2"
                                    ></v-img>
                                  </span>
                                <span v-else>
                                  {{ item.key }}
                                    {{ item.value }}
                                </span>
                            </template>
                        </v-data-table>
                        <div v-else>
                            Brak danych
                        </div>

                    </div>
                  <v-row>
                    <v-col cols="12">
                      <v-card :color="order.supervisor ? order.supervisor.color : ''">
                        <v-card-text>
                          <v-autocomplete
                              v-model="order.supervisor"
                              :items="supervisors"
                              item-value="id"
                              item-text="email"
                              label="Opiekun zamówienia"
                          >
                            <template v-slot:selection="data">
                              {{ data.item.name }} {{ data.item.surname }} - {{ data.item.email }}
                            </template>
                            <template v-slot:item="data">
                              {{ data.item.name }} {{ data.item.surname }} - {{ data.item.email }}
                            </template>
                          </v-autocomplete>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-card>
                        <v-card-text>
                          <v-autocomplete
                              v-model="order.whoTransport"
                              :items="whoTransport"
                              item-value="value"
                              item-text="text"
                              label="Kto odpowiada za transport"
                          ></v-autocomplete>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                    <div class="my-3 text-center">
                        <vue-dropzone id="dropzone" ref="dropzone" class="mb-2" :options="dropzoneOptions"
                                    v-on:vdropzone-success="storeImageId" v-on:vdropzone-removed-file="removeImage"></vue-dropzone>
                        <ckeditor
                            :editor="editor"
                            v-model="order.notes"
                            :config="editorConfig"
                        ></ckeditor>
                        <v-btn
                            :disabled="loadingDetails"
                            @click="update"
                            class="mt-4 text-center"
                        >
                            Zapisz
                        </v-btn>
                    </div>
                    <div class="my-3 text-center">
                        <v-btn
                            :disabled="loadingDetails"
                            v-if="canBeHandOver"
                            @click="handOver"
                            class="mx-1"
                            color="orange lighten-1"
                        >
                            Przekaż do partnera
                        </v-btn>
                        <v-btn
                            :disabled="loadingDetails"
                            ref="soldBtn"
                            :href="reorderUrl"
                            target="_blank"
                            class="mx-1"
                            color="green lighten-1"
                        >
                            Zamów ponownie
                        </v-btn>
                        <v-btn v-if="canBeCancelled"
                               :disabled="loadingDetails"
                               ref="soldBtn"
                               @click="cancel"
                               class="mx-1"
                               color="red lighten-1"
                        >
                            Oznacz jako anulowane
                        </v-btn>
                        <v-btn v-if="canBeProcessed"
                               :disabled="loadingDetails"
                               ref="processBtn"
                               @click="proccess"
                               class="mx-1"
                               color="orange lighten-1"
                        >
                            Oznacz jako przyjęte do realizacji
                        </v-btn>
                        <v-btn v-if="canBeCompleted"
                               :disabled="loadingDetails"
                               ref="completeBtn"
                               @click="complete"
                               class="mx-1"
                               color="green lighten-1"
                        >
                            Oznacz jako wykonane
                        </v-btn>
                        <v-text-field v-if="canBeCompleted" v-model="quantity" v-bind:suffix="order.service.unit"
                                      class="mx-1 d-inline-flex">
                        </v-text-field>
                        <v-text-field v-if="canBeCompleted" v-model="price" v-bind:suffix="'zł/' + order.service.unit"
                                      class="mx-1 d-inline-flex">
                        </v-text-field>
                    </div>
                  <PotentiallyInterestedCompanies
                      class="mt-5"
                      :orderId="this.id"
                      :potentiallyInterestedVisible="true"
                  />
                    <v-data-table
                        v-if="loadingDetails || order.historyData.length"
                        :headers="historyHeaders"
                        :items="order.historyData"
                        class="elevation-1"
                        :loading="loadingDetails"
                    >
                        <template v-slot:item.type="{ item }">
                            {{ item.type === 'STATUS_CHANGED' ? 'Zmiana statusu' : 'Zmiana ceny' }}
                        </template>
                        <template v-slot:item.data="{ item }">
                            <span v-if="item.type === 'STATUS_CHANGED'">
                                Stary status <strong>{{ getOrderStatusText(item.data['oldStatus']) }}</strong> Nowy status <strong>{{ getOrderStatusText(item.data['newStatus']) }}</strong>
                            </span>
                            <span v-else>
                                Stara cena <strong>{{ item.data['oldPrice'] }}</strong> Nowa cena <strong>{{ item.data['newPrice'] }}</strong>
                            </span>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import api from '../services/api';
import formatters from "@/mixins/formatters";
import permissions from "@/mixins/permissions";
import {getStatusText as getOrderStatusText} from '@/enums/OrderStatus';
import {getItems as getCompanyTypeItems, getTypeText} from "@/enums/CompanyType";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from '../utils/ckeditor5/build/ckeditor';
import ModalHandOverToPartner from "../components/ModalHandOverToPartner";
import ModalSetPrices from "../components/ModalSetPrices";
import vue2Dropzone from "vue2-dropzone";
import {Auth} from "@/services/Auth";
import PotentiallyInterestedCompanies from "@/components/PotentiallyInterestedCompanies.vue";
import ModalCancelOrder from "@/components/ModalCancelOrder.vue";
import ModalSetDescription from "@/components/ModalSetDescription.vue";
import ModalSetQuantity from "@/components/ModalSetQuantity.vue";

export default {
    components: {
      ModalSetQuantity,
      ModalSetDescription,
      ModalCancelOrder,
      PotentiallyInterestedCompanies,
        ModalSetPrices,
        ModalHandOverToPartner,
        ckeditor: CKEditor.component,
        vueDropzone: vue2Dropzone,
    },
    mixins: [
        formatters,
        permissions,
    ],
    props: ['id'],
    data() {
        return {
            dialog: false,
            orderId: null,
            quantity: null,
            price: null,
            photos: [],
            supervisors: [],
            companyType: '',
            companyTypes: [
                ...getCompanyTypeItems(),
            ],
            whoTransport: [
              {value: null, text: 'Wybierz'},
              {value: 'client', text: 'Klient'},
              {value: 'seller', text: 'Usługodawca'},
              {value: 'wm', text: 'Wastemaster'},
            ],
            companyTextTypes: getTypeText,
            orderAttributesMap: {
                status: 'Status',
                completionDate: 'Do kiedy odpad zostanie odebrany',
                user: 'Użytkownik',
                createdAtDto: 'Utworzono',
                price: 'Cena',
                partnerPrice: 'Cena partnera',
                cancelReason: 'Powód anulowania',
                fuel: 'Paliwo',
                transmission: 'Skrzynia biegów',
                sourcePageTitle: 'Źródło (strona zapytania)',
            },
            fuelTypes: {
              GAS: 'Benzyna',
              DIESEL: 'Diesel',
              GAS_LPG: 'Benzyna + LPG',
              HYBRID: 'Hybryda',
              ELECTRIC: 'Elektryczny',
            },
            transmissionTypes: {
              MANUAL: 'Manualna',
              AUTOMATIC:'Automatyczna'
            },
            typeMap: {
              paidUtilization: 'Płatna utylizacja',
              wastePurchase: 'Kupno odpadu',
              wasteFree: 'Bezpłatny odbiór',
            },
            headers: [
                {text: '', value: 'name'},
                {text: '', value: 'value'},
            ],
            historyHeaders: [
                { text: 'Typ', value: 'type' },
                { text: 'Zmiana', value: 'data' },
                { text: 'Kto dokonał zmiany', value: 'userEmail' },
                { text: 'Kiedy dokonano zmiany', value: 'created' },
            ],
            order: {},
            historyData: [],
            details: [],
            companyDetails: [],
            loadingDetails: false,
            dropzoneOptions: {
                url: `${process.env.VUE_APP_API_URL}/api/files`,
                thumbnailWidth: 150,
                maxFilesize: 1024 * 20,
                acceptedFiles: 'image/*',
                addRemoveLinks: true,
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem(Auth.TOKEN_KEY)}`
                }
            },
            apiBaseUrl: process.env.VUE_APP_API_URL,
            appBaseUrl: process.env.VUE_APP_APP_URL,
            editor: ClassicEditor,
            editorConfig: {
                htmlSupport: {
                    allow: [
                        {
                            name: /.*/,
                            attributes: true,
                            classes: true,
                            styles: true
                        }
                    ],
                }
            },
            reorderUrl: null
        }
    },
    methods: {
        async loadDetails() {
            this.loadingDetails = true;

            const orderResponse = await api.get(`/api/orders/${this.orderId}`);
            this.order = orderResponse.data
            this.details.length = 0; // Trick to empty the array without changing the reference!
            this.loadingDetails = false;
            this.companyDetails = [
                {
                    name: 'company',
                    value: {
                        name: this.order.service.company.name,
                        nip: this.order.service.company.nip,
                    },
                },
                {
                    name: 'branchName',
                    value: this.order.service.branch.name,
                },
                {
                    name: 'branchId',
                    value: {
                        branch: this.order.service.branch.id,
                        company: this.order.service.company.id,
                    },
                }
            ];

            this.details.push({
              name: 'Samochód',
                  value: `${this.order.service.name} (${this.order.service.type.name})`,
            });
            for (const [key, value] of Object.entries(orderResponse.data)) {
                if (key in this.orderAttributesMap) {
                    if (key === 'sourcePageTitle' && !value) {
                      continue;
                    }
                    if (key === 'fuel') {
                      this.details.push({
                        name: this.orderAttributesMap[key],
                        value: this.fuelTypes[value]
                      })
                      continue;
                    }
                    if (key === 'transmission') {
                      this.details.push({
                        name: this.orderAttributesMap[key],
                        value: this.transmissionTypes[value]
                      })
                      continue;
                    }
                    this.details.push({
                        name: this.orderAttributesMap[key],
                        value: value
                    })

                    if (key === 'price') {
                      this.details.push({
                        name: 'Email partnera',
                        value: orderResponse.data.partnerData && orderResponse.data.partnerData['email'] !== undefined ? orderResponse.data.partnerData['email'] : '-'
                      })
                    }
                }
            }

            Object.entries(orderResponse.data.additionalData).forEach(element => {
                let key = element[0];
                let value = element[1];

                if (value !== null && value.toString().search("storageId") > 0) {
                    value = JSON.parse(value);
                }

                this.details.push({
                    name: key,
                    value: value
                })
            })

            this.details.push({
                name: 'Uwagi od partnera',
                value: orderResponse.data.partnerNotes ?? '',
            })
            this.quantity = orderResponse.data.additionalDataRaw['quantity'];
            this.price = this.formatAmount(orderResponse.data.price, 1);
            this.reorderUrl = process.env.VUE_APP_LANDING_URL + `/?order=${orderResponse.data.service.id}&withTransport=${orderResponse.data.withTransport ? 'true' : 'false'}&detailsToken=${orderResponse.data.detailsToken}&reorderToken=${orderResponse.data.reorderToken}`

        },
        async loadSupervisors() {
            const supervisorsResponse = await api.get(`/api/users?role=ROLE_SUPERVISOR`);
            this.supervisors = [{id: 0, email: "Wybierz opiekuna"}].concat(supervisorsResponse.data.items)
        },
        async proccess() {
            if (this.loadingDetails) {
                return;
            }

            this.loadingDetails = true;
            await api.post(`/api/orders/${this.orderId}/processing`)
                .then((response) => {
                    this.details.forEach((object) => {
                        if (object.name === 'Status') {
                            // Update status.
                            object.value = response.data.status;
                            this.order.status = object.value;
                        }
                    });

                    const expectedStatus = 'processing';

                    if (expectedStatus !== response.data.status) {
                        this.$root.$emit('notifyError', {
                            html:
                                'Nie udało się ustawić statusu - ' +
                                `server zwrócił status "${response.data.status}" zamiast "${expectedStatus}".`
                        });

                        return;
                    }

                    this.$root.$emit('notifySuccess', {
                        html: 'Zamówienie w trakcie przetwarzania.'
                    });
                })
                .catch((error) => {
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się ustawić statusu.',
                        error
                    });
                })
                .finally(() => {
                    this.loadingDetails = false;
                });
        },

        async handOver() {
            this.$refs.handOverDialog
                .open(this.order)
        },

        async cancel() {
            if (this.loadingDetails) {
                return;
            }
            this.$refs.cancelOrderDialog.open();
        },

        async complete() {
            if (this.loadingDetails) {
                return;
            }

            this.loadingDetails = true;
            await api.post(`/api/orders/${this.orderId}/complete`, {
                quantity: this.quantity,
                price: this.price.replace(',', '.')
            })
                .then((response) => {
                    this.details.forEach((object) => {
                        if (object.name === 'Status') {
                            // Update status.
                            object.value = response.data.status;
                            this.order.status = object.value;
                        }
                        if (object.name === 'Ilość') {
                            object.value = response.data.additionalData['Ilość'];
                            this.order.quantity = object.value;
                        }
                    });

                    const expectedStatus = 'completed';

                    if (expectedStatus !== response.data.status) {
                        this.$root.$emit('notifyError', {
                            html:
                                'Nie udało się ustawić statusu - ' +
                                `server zwrócił status "${response.data.status}" zamiast "${expectedStatus}".`
                        });

                        return;
                    }

                    this.$root.$emit('notifySuccess', {
                        html: 'Zamówienie zostało zatwierdzone.'
                    });
                })
                .catch((error) => {
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się zatwierdzić zamówienia.',
                        error
                    });
                })
                .finally(() => {
                    this.loadingDetails = false;
                });
        },


        async update() {
            if (this.loadingDetails) {
                return;
            }

            this.loadingDetails = true;
            await api.put(`/api/orders/${this.orderId}`, {notes: this.order.notes, photos: this.photos, whoTransport: this.order.whoTransport, supervisor: typeof this.order.supervisor === 'object' && this.order.supervisor !== null? this.order.supervisor.id : this.order.supervisor})
                .then(() => {
                    this.$root.$emit('notifySuccess', {
                        html: 'Zamówienie zostało zaktualizowane.'
                    });
                    this.loadDetails();
                    this.$refs.dropzone.removeAllFiles()
                })
                .catch((error) => {
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się zaktualizować zamówienia.',
                        error
                    });
                })
                .finally(() => {
                    this.loadingDetails = false;
                });
        },

        getOrderStatusText(status) {
            return getOrderStatusText(status);
        },
        setPrices() {
            this.$refs.setPricesDialog
                .open(this.order)
        },
        setQuantity() {
            this.$refs.setQuantityDialog
                .open(this.order)
        },
        setDescription() {
            this.$refs.setDescriptionDialog
                .open(this.order)
        },
        storeImageId(event, image) {
            this.photos.push(image);
        },
        removeImage() {
            this.photos = [];
        },
    },
    computed: {
        canBeCancelled() {
            return (this.isAdmin() || this.isTrader()) &&
                this.order && (this.order.status === 'new' || this.order.status === 'processing' || this.order.status === 'priceProposal' || this.order.status === 'priceRejected' || this.order.status === 'priceAccepted' || this.order.status === 'pendingPartnerAccept' || this.order.status === 'pendingPartnerPricing' || this.order.status === 'partnerPriced' || this.order.status === 'partnerAccepted' || this.order.status === 'partnerRejected');
        },
        canBeHandOver() {
            return (this.isAdmin() || this.isTrader()) && this.order && (this.order.status === 'new' || this.order.status === 'partnerPriced' || this.order.status === 'priceAccepted');
        },
        canBeProcessed() {
            return (this.isAdmin() || this.isTrader()) &&
                this.order && (this.order.status === 'new' || this.order.status === 'priceAccepted' || this.order.status === 'priceProposal' || this.order.status === 'pendingPartnerAccept' || this.order.status === 'pendingPartnerPricing' || this.order.status === 'partnerPriced' || this.order.status === 'partnerAccepted');
        },
        canBeCompleted() {
            return (this.isAdmin() || this.isTrader()) &&
                this.order && (this.order.status === 'processing' || this.order.status === 'priceAccepted' || this.order.status === 'priceProposal' || this.order.status === 'pendingPartnerAccept' || this.order.status === 'pendingPartnerPricing' || this.order.status === 'partnerPriced' || this.order.status === 'partnerAccepted');
        }
    },
    async created() {
        try {
            this.orderId = this.id; // Store new user id in the local variable.
            await this.loadDetails();
            await this.loadSupervisors();
        } catch (e) {
            void (0);
        }
    },
    async beforeRouteUpdate(to, from, next) {
        next(); // Update the URL in address bar.
        this.orderId = to.params.id; // Store new user id in the local variable.
        await this.loadDetails();
    },
}
</script>

<style scoped>
.v-data-table
/deep/
tbody
/deep/
tr:hover:not(.v-data-table__expanded__content) {
    background: #ffffff !important;
}
</style>
<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
    cursor: pointer;
}
</style>